<template>
  <g>
    <g clip-path="url(#clip0_15_1179)">
      <path
        d="M10.85 18.8502C10.54 18.5402 10 18.7602 10 19.2102V20.0002H6C5.45 20.0002 5 20.4502 5 21.0002C5 21.5502 5.45 22.0002 6 22.0002H10V22.7902C10 23.2402 10.54 23.4602 10.85 23.1402L12.64 21.3502C12.84 21.1502 12.84 20.8402 12.64 20.6402L10.85 18.8502ZM18 20.0002H15C14.45 20.0002 14 20.4502 14 21.0002C14 21.5502 14.45 22.0002 15 22.0002H18C18.55 22.0002 19 21.5502 19 21.0002C19 20.4502 18.55 20.0002 18 20.0002ZM17 0.000183105H7C5.9 0.000183105 5 0.900183 5 2.00018V16.0002C5 17.1002 5.9 18.0002 7 18.0002H17C18.1 18.0002 19 17.1002 19 16.0002V2.00018C19 0.900183 18.1 0.000183105 17 0.000183105ZM12 6.00018C10.89 6.00018 10 5.10018 10 4.00018C10 2.90018 10.89 2.00018 11.99 2.00018C13.09 2.00018 13.99 2.90018 13.99 4.00018C14 5.10018 13.1 6.00018 12 6.00018Z"
      />
    </g>
    <defs>
      <clipPath id="clip0_15_1179">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0 0.000183105)"
        />
      </clipPath>
    </defs>
  </g>
</template>
